import _ from "lodash";
import {
  getOrganizationId,
  getSelectedAcademicYear,
  getSelectedAcademicYearId,
  getSelectedCurriculumId,
  getSelectedAcademicYearStartDate,
  getSelectedAcademicYearEndDate,
  getUserCurriculumPrograms,
} from "modules/CommonSelectors";

import {
  getAttendanceExcusalStatus,
  getExcusalDate,
  checkIsEnableEnrolWithdrawalDateEnabled,
} from "AttendanceDashboard/modules/Utils";
import { ATTENDANCE_CONSTANTS } from "AttendanceDashboard/constants/stringConstants";
import { ATTENDANCE_CONSTANTS as CONSTANTS } from "Constants/attendanceConstants";

import {
  formatDate,
  getTodaysDate,
  getNextDayDate,
} from "Utils/DateTimeHelpers";

import moment from "moment";

const getHomeroomActiveTab = state => {
  return _.get(state, "homeroom.activeTab", ATTENDANCE_CONSTANTS.STUDENTS);
};

const getHomeroomSelectedDatesObject = state => {
  return _.get(state, "homeroom.selectedDatesObject", {});
};

const checkIsCustomRangeModalVisible = state => {
  return _.get(state, "homeroom.isCustomRangeModalVisible", false);
};

const getExcusalCount = node => {
  const newExcusals = _.get(node, "newExcusals");
  const upcomingAndOngoingExcusals = _.get(node, "upcomingAndOngoingExcusals");
  const markedExcusals = _.get(node, "markedExcusals");
  const students = _.get(node, "students.edges", []);

  return {
    newExcusals,
    upcomingAndOngoingExcusals,
    markedExcusals,
    students,
  };
};

const getStudentFiltersForExcusal = ({
  curriculumProgramId,
  academicYearId,
}) => {
  return {
    academicYearIds: academicYearId,
    curriculumProgramIds: curriculumProgramId,
    visibleTo: ATTENDANCE_CONSTANTS.HOMEROOM_UPPERCASE,
  };
};

const getCurriculumGlobalConstantsQueryFilter = (
  currentAcademicYearId,
  curriculumProgramId,
  constantsName
) => {
  return {
    academicYearIds: currentAcademicYearId,
    curriculumProgramIds: curriculumProgramId,
    names: constantsName,
  };
};

const getOrganizationHomeroomExcusalFilterVariable = (
  state,
  isNewExcusal,
  searchValue,
  filterConfig,
  selectedCategory,
  isMarkedExcusals,
  isOngoingExcusalVisible,
  curriculumProgramId
) => {
  const updateFilterConfig = _.head(filterConfig);
  const { direction, sortEntity } = updateFilterConfig;
  const selectedAcademicYear = getSelectedAcademicYear(state);
  const academicYearId = _.get(selectedAcademicYear, "id", null);

  const todayFormatted = formatDate({
    date: getTodaysDate(),
    format: ATTENDANCE_CONSTANTS.YYYY_MM_DD,
  });

  const nextDayFormatted = formatDate({
    date: getNextDayDate(),
    format: ATTENDANCE_CONSTANTS.YYYY_MM_DD,
  });

  const { startDate, endDate } = _.get(
    state,
    "homeroom.selectedDatesObject",
    {}
  );

  const activeExcusalsFilters = isOngoingExcusalVisible
    ? {
        startDate: todayFormatted,
        endDate: todayFormatted,
        searchText: searchValue,
        attendanceExcusalStatus: getAttendanceExcusalStatus(isNewExcusal),
        statusByDuration: ATTENDANCE_CONSTANTS.ONGOING,
        attendanceOptionIds: selectedCategory,
        curriculumProgramIds: curriculumProgramId,
        academicYearIds: academicYearId,
        visibleTo: ATTENDANCE_CONSTANTS.HOMEROOM_UPPERCASE,
      }
    : undefined;

  return {
    id: getOrganizationId(state),
    first: 15,
    orderBy: sortEntity,
    orderByDirection: direction,
    activeExcusalsFilters,
    filters: {
      startDate: isMarkedExcusals
        ? startDate
        : isOngoingExcusalVisible
        ? nextDayFormatted
        : formatDate({
            date: getSelectedAcademicYearStartDate({ selectedAcademicYear }),
            format: ATTENDANCE_CONSTANTS.YYYY_MM_DD,
          }),
      endDate: isMarkedExcusals
        ? endDate
        : formatDate({
            date: getSelectedAcademicYearEndDate({ selectedAcademicYear }),
            format: ATTENDANCE_CONSTANTS.YYYY_MM_DD,
          }),
      searchText: searchValue,
      attendanceExcusalStatus: getAttendanceExcusalStatus(isNewExcusal),
      statusByDuration: isOngoingExcusalVisible
        ? ATTENDANCE_CONSTANTS.UPCOMING
        : undefined,
      attendanceOptionIds: selectedCategory,
      ...getStudentFiltersForExcusal({
        curriculumProgramId,
        academicYearId,
      }),
    },
    isOngoingExcusalVisible,
  };
};

const getRefectchQueryVariableForExcusal = ({
  isHomeroom,
  sideBarManager,
  organizationId,
  selectedAcademicYear,
  curriculumProgramId,
  selectedDatesObject,
  isNewExcusal,
  searchValue,
  filterConfig,
  selectedCategory,
  isMarkedExcusals,
  isOngoingExcusalVisible,
  courseIds,
  attendanceOptionIds,
}) => {
  const { isStudent, selectedKey, studentDetails } = sideBarManager;
  const studentId = _.get(studentDetails, "id", null);
  if (isStudent) {
    return {
      id: studentId,
      studentExcusalFilters: {
        attendanceOptionIds: selectedCategory,
      },
    };
  }

  const { direction, sortEntity } = filterConfig;
  const academicYearId = _.get(selectedAcademicYear, "id", null);

  const todayFormatted = formatDate({
    date: getTodaysDate(),
    format: ATTENDANCE_CONSTANTS.YYYY_MM_DD,
  });

  const nextDayFormatted = formatDate({
    date: getNextDayDate(),
    format: ATTENDANCE_CONSTANTS.YYYY_MM_DD,
  });

  const activeExcusalsFilters = isOngoingExcusalVisible
    ? {
        startDate: todayFormatted,
        endDate: todayFormatted,
        searchText: searchValue,
        attendanceExcusalStatus: getAttendanceExcusalStatus(isNewExcusal),
        statusByDuration: ATTENDANCE_CONSTANTS.ONGOING,
        attendanceOptionIds: isHomeroom
          ? selectedCategory
          : attendanceOptionIds,
        curriculumProgramIds: curriculumProgramId,
        academicYearIds: academicYearId,
        courseIds: !isHomeroom ? courseIds : undefined,
        visibleTo: isHomeroom
          ? ATTENDANCE_CONSTANTS.HOMEROOM_UPPERCASE
          : undefined,
      }
    : undefined;

  const startDateForNewExcusals = isHomeroom
    ? formatDate({
        date: getSelectedAcademicYearStartDate({ selectedAcademicYear }),
        format: ATTENDANCE_CONSTANTS.YYYY_MM_DD,
      })
    : getExcusalDate(
        selectedKey,
        getSelectedAcademicYearStartDate({ selectedAcademicYear }),
        ATTENDANCE_CONSTANTS.START
      );

  const endDateForNewExcusals = isHomeroom
    ? formatDate({
        date: getSelectedAcademicYearEndDate({ selectedAcademicYear }),
        format: ATTENDANCE_CONSTANTS.YYYY_MM_DD,
      })
    : getExcusalDate(
        selectedKey,
        getSelectedAcademicYearEndDate({ selectedAcademicYear }),
        ATTENDANCE_CONSTANTS.END
      );

  return {
    id: organizationId,
    first: 15,
    orderBy: sortEntity,
    orderByDirection: direction,
    activeExcusalsFilters,
    filters: {
      startDate: isMarkedExcusals
        ? _.get(selectedDatesObject, "startDate")
        : isOngoingExcusalVisible
        ? nextDayFormatted
        : startDateForNewExcusals,
      endDate: isMarkedExcusals
        ? _.get(selectedDatesObject, "endDate")
        : endDateForNewExcusals,
      searchText: searchValue,
      attendanceExcusalStatus: getAttendanceExcusalStatus(isNewExcusal),
      statusByDuration: isOngoingExcusalVisible
        ? ATTENDANCE_CONSTANTS.UPCOMING
        : undefined,
      attendanceOptionIds: isHomeroom ? selectedCategory : attendanceOptionIds,
      academicYearIds: academicYearId,
      curriculumProgramIds: curriculumProgramId,
      courseIds: !isHomeroom ? courseIds : undefined,
      visibleTo: isHomeroom
        ? ATTENDANCE_CONSTANTS.HOMEROOM_UPPERCASE
        : undefined,
    },
    isOngoingExcusalVisible,
  };
};

export const getRefectchQueryVariableForExcusalMemoized = _.memoize(
  getRefectchQueryVariableForExcusal,
  params => JSON.stringify(params)
);

const getRefectchQueryVariableForExcusalCounts = ({
  isHomeroom,
  organizationId,
  curriculumProgramId,
  academicYearId,
  academicYearStartDate,
  academicYearEndDate,
  allCoursesId,
  attendanceOptionIds,
}) => {
  const excusalFilters = {
    startDate: academicYearStartDate,
    endDate: academicYearEndDate,
    academicYearIds: academicYearId,
    curriculumProgramIds: curriculumProgramId,
    visibleTo: isHomeroom ? ATTENDANCE_CONSTANTS.HOMEROOM_UPPERCASE : undefined,
    attendanceExcusalStatus: ATTENDANCE_CONSTANTS.PENDING,
    courseIds: !isHomeroom ? allCoursesId : undefined,
    attendanceOptionIds: !isHomeroom ? attendanceOptionIds : undefined,
  };

  return {
    id: organizationId,
    newExcusalsFilters: excusalFilters,
    upcomingAndOngoingExcusalsFilters: {
      ...excusalFilters,
      startDate: formatDate({
        date: moment(),
        format: ATTENDANCE_CONSTANTS.YYYY_MM_DD,
      }),
      attendanceExcusalStatus: ATTENDANCE_CONSTANTS.MARKED,
    },
    markedExcusalsFilters: {
      ...excusalFilters,
      attendanceExcusalStatus: ATTENDANCE_CONSTANTS.MARKED,
    },
    studentsFilters: isHomeroom
      ? {
          academicYearIds: academicYearId,
          curriculumProgramIds: curriculumProgramId,
          visibleTo: ATTENDANCE_CONSTANTS.HOMEROOM_UPPERCASE,
        }
      : undefined,
  };
};

export const getRefectchQueryVariableForExcusalCountsMemoized = _.memoize(
  getRefectchQueryVariableForExcusalCounts,
  params => JSON.stringify(params)
);

const getStudentTabsOverViewFilters = (
  organizationId,
  startDate,
  endDate,
  searchValue,
  isDailyView,
  isAttendanceOnceADay,
  curriculumProgramId,
  currentAcademicYearId,
  showHomeroomAttendance,
  studentStatus = ATTENDANCE_CONSTANTS.ALL
) => {
  return {
    id: organizationId,
    studentsFilters: {
      searchText: searchValue,
      curriculumProgramIds: curriculumProgramId,
      visibleTo: ATTENDANCE_CONSTANTS.HOMEROOM_UPPERCASE,
      academicYearIds: currentAcademicYearId,
      archivalState: studentStatus,
      enrollmentBeforeFilter: checkIsEnableEnrolWithdrawalDateEnabled()
        ? endDate
        : undefined,
    },
    anomalyStudentsFilters: {
      searchText: searchValue,
      attendanceFilters: {
        dates: {
          startDate: startDate ? startDate : endDate,
          endDate,
        },
        showStudentAttendanceAnomaly: true,
      },
      visibleTo: ATTENDANCE_CONSTANTS.HOMEROOM_UPPERCASE,
      academicYearIds: currentAcademicYearId,
      archivalState: studentStatus,
    },
    organizationAttendanceV2Filters: {
      startDate: startDate ? startDate : endDate,
      endDate,
      searchText: searchValue,
      isPeriodByAttendance: !isAttendanceOnceADay,
      visibleTo: ATTENDANCE_CONSTANTS.HOMEROOM_UPPERCASE,
      academicYearIds: currentAcademicYearId,
      curriculumProgramIds: curriculumProgramId,
      onlyHomeroomAttendance: showHomeroomAttendance,
    },
    isPeriodAttendanceView: isDailyView,
  };
};

const getSelectedStaffCourse = (queryDataNode, periodId) => {
  const staffId = _.get(queryDataNode, "id", null);
  const courses = _.get(queryDataNode, "courses", []);

  const selectedCourseObject = _.find(courses, course => {
    const isStaffResponsible = _.find(
      _.get(course, "periodsV2.edges"),
      ({ node }) => {
        const { isSelected, teachers, period } = node || {};
        return (
          isSelected &&
          !_.isEmpty(_.find(teachers, ({ id }) => id === staffId)) &&
          periodId === _.get(period, "id", null)
        );
      }
    );

    return !_.isEmpty(isStaffResponsible);
  });

  return {
    selectedCourseId: _.get(selectedCourseObject, "id"),
  };
};

const getSelectedStaffCourseV2 = ({
  queryDataNode,
  periodId,
  isToddleV2TimetableEnabled,
}) => {
  const staffId = _.get(queryDataNode, "id", null);
  const courses = _.get(queryDataNode, "courses", []);

  const selectedCourseObject = _.find(courses, course => {
    const courses = isToddleV2TimetableEnabled
      ? _.get(course, "periodsV4.edges")
      : _.get(course, "periodsV3.edges");

    const isStaffResponsible = _.find(courses, ({ node }) => {
      const { isSelected, teachers, period } = node || {};

      return (
        isSelected &&
        !_.isEmpty(
          _.find(teachers, ({ id, staff }) =>
            isToddleV2TimetableEnabled
              ? _.get(staff, "id") === staffId
              : id === staffId
          )
        ) &&
        periodId === _.get(period, "id", null)
      );
    });

    return !_.isEmpty(isStaffResponsible);
  });

  return {
    selectedCourseId: _.get(selectedCourseObject, "id"),
  };
};

const getStudentsWithoutHomeroom = queryDataNode => {
  return {
    studentsTotalCount: _.get(queryDataNode, "students.totalCount", 0),
    studentsEdges: _.get(queryDataNode, "students.edges", []),
  };
};

const getStudentsFilters = (
  state,
  searchStudent,
  selectedCurriculumId,
  selectedCourses,
  selectedHomeroomAdvisorStatus
) => {
  const userCurriculumPrograms = getUserCurriculumPrograms(state);
  const userCurriculumProgramIds = _.map(
    userCurriculumPrograms,
    ({ id }) => id
  );
  const homeroomFilters = {
    studentHomeroomStatus:
      selectedHomeroomAdvisorStatus || ATTENDANCE_CONSTANTS.NOT_CONNECTED,
  };

  return {
    searchTextFields: [CONSTANTS.NAME, CONSTANTS.SOURCED_ID],
    academicYearIds: getSelectedAcademicYearId(state),
    archivalState: CONSTANTS.ACTIVE,
    homeroomFilters,
    searchText: searchStudent,
    curriculumProgramIds:
      selectedCurriculumId === ATTENDANCE_CONSTANTS.ALL_CURRICULUMS
        ? userCurriculumProgramIds
        : selectedCurriculumId,
    courses: selectedCourses,
  };
};

const getStaffRelationFilters = (state, isCurriculumApplicable = false) => {
  return {
    relation: ATTENDANCE_CONSTANTS.HOMEROOM_UPPERCASE,
    academicYearIds: getSelectedAcademicYearId(state),
    curriculumProgramIds: isCurriculumApplicable
      ? getSelectedCurriculumId(state)
      : undefined,
    archivalState: "ALL",
  };
};

const getAllCoursesFilters = ({ state, selectedCurriculumId }) => {
  return {
    id: getOrganizationId(state),
    filters: {
      academicYears: getSelectedAcademicYearId(state),
      curriculumProgramIds: [selectedCurriculumId],
    },
  };
};

const getMarkedExcusalsFilters = ({
  startDate,
  endDate,
  searchValue,
  statusByDuration,
  selectedCategory,
  courseIds,
}) => {
  return {
    startDate: formatDate({
      date: startDate,
      format: ATTENDANCE_CONSTANTS.YYYY_MM_DD,
    }),
    endDate: formatDate({
      date: endDate,
      format: ATTENDANCE_CONSTANTS.YYYY_MM_DD,
    }),
    searchText: searchValue,
    attendanceExcusalStatus: ATTENDANCE_CONSTANTS.MARKED,
    statusByDuration,
    attendanceOptionIds: selectedCategory,
    courseIds,
  };
};

const getCourseMarkedExcusalsFilters = (
  state,
  organizationId,
  searchValue,
  selectedCategory,
  courseId,
  academicYearId
) => {
  const selectedAcademicYear = getSelectedAcademicYear(state);

  return {
    id: organizationId,
    first: 15,
    orderBy: ATTENDANCE_CONSTANTS.EXCUSAL_START_DATE,
    orderByDirection: ATTENDANCE_CONSTANTS.DESC,
    activeExcusalsFilters: getMarkedExcusalsFilters({
      startDate: getTodaysDate(),
      endDate: getTodaysDate(),
      searchValue,
      statusByDuration: ATTENDANCE_CONSTANTS.ONGOING,
      selectedCategory,
      courseIds: courseId,
    }),
    upcomingExcusalsFilters: getMarkedExcusalsFilters({
      startDate: getNextDayDate(),
      endDate: getSelectedAcademicYearEndDate({ selectedAcademicYear }),
      searchValue,
      statusByDuration: ATTENDANCE_CONSTANTS.UPCOMING,
      selectedCategory,
      courseIds: courseId,
    }),
    studentArchivedFilters: {
      academicYearId,
    },
  };
};

const getCourseMarkedExcusalsData = node => {
  return {
    activeExcusalsCount: _.get(node, "activeExcusals.totalCount", 0),
    activeExcusals: _.get(node, "activeExcusals.edges", []),
    upcomingExcusalsCount: _.get(node, "upcomingExcusals.totalCount", 0),
    upcomingExcusals: _.get(node, "upcomingExcusals.edges", []),
  };
};

const getStudentsCountFilters = ({ curriculumProgramId, academicYearId }) => {
  return {
    curriculumProgramIds: curriculumProgramId,
    archivalState: ATTENDANCE_CONSTANTS.ARCHIVED,
    visibleTo: ATTENDANCE_CONSTANTS.HOMEROOM_UPPERCASE,
    academicYearIds: academicYearId,
  };
};

export {
  getHomeroomActiveTab,
  getHomeroomSelectedDatesObject,
  checkIsCustomRangeModalVisible,
  getExcusalCount,
  getStudentFiltersForExcusal,
  getCurriculumGlobalConstantsQueryFilter,
  getOrganizationHomeroomExcusalFilterVariable,
  getStudentTabsOverViewFilters,
  getSelectedStaffCourse,
  getSelectedStaffCourseV2,
  getStudentsWithoutHomeroom,
  getStudentsFilters,
  getStaffRelationFilters,
  getAllCoursesFilters,
  getCourseMarkedExcusalsFilters,
  getCourseMarkedExcusalsData,
  getStudentsCountFilters,
};
